






import Vue from 'vue';
import { Home } from '@/screens';

export default Vue.extend({
  name: 'app',
  components: {
    Home,
  },
});
